import { GridApi } from 'ag-grid-community';

export function setRowVisible(gridApi: GridApi, key: string) {
    const rowNode = gridApi.getRowNode(key);

    rowNode && gridApi.ensureIndexVisible(rowNode.rowIndex, 'middle');
}
